import { sortByOrder } from "@utils/array";

import { request } from "./index";

const fetchPricingProducts = async <T>() => {
  return request<T>({ method: "post", url: `/pricing/membership` });
};

const fetchIndProducts = async <T>() => {
  return request<T>({ method: "post", url: `/pricing/others` });
};

const createOrder = async <T>(reqData: unknown) => {
  return request<T>({ method: "post", url: `/order/createOrder`, data: reqData });
};

const getFeture = async <T>(reqData: unknown) => {
  return request<T>({ method: "post", url: `/user/features`, data: reqData });
};

const getPaymentMethod = async <T>() => {
  return request<T>({ method: "get", url: `/pricing/getPaymentMethod` });
};

const queryOrder = async <T>(reqData: unknown) => {
  return request<T>({ method: "get", url: `/api/pay/queryOrder?orderId=${reqData}` });
};

const queryMeLiveRecord = async <T>(reqData: unknown) => {
  return request<T>({ method: "post", url: `/livestream/queryLiveList`, data: reqData });
};

const requestPayMembership = async <T>(data: object, language: string) => {
  const param = encodeURIComponent(JSON.stringify(data));
  return request<T>({
    method: "GET",
    url: `/order/goToPay?param=${param}&language=${language}`,
  });
};

const checkAlipayQueryOrder = async <T>(orderId: string) => {
  return request<T>({
    method: "GET",
    url: `/order/alipay/queryOrder?orderId=${orderId}`,
  });
};

const querySubscription = async (reqData: { skuId: string; itemId: string }) => {
  return request<{
    percent: number;
    currency: string;
    price: number;
  }>({ method: "post", url: `/pricing/querySubscription`, data: reqData });
};

const queryExchangeRate = async (reqData: { currency: string }) => {
  return request<number>({ method: "post", url: `/pricing/queryExchangeRate`, data: reqData });
};

const queryDiscountInfo = async (reqData: {
  productList: { productId: string; skuId: string }[];
  promotionCode: string;
}) => {
  return request<{ promotionValue: number }>({ method: "post", url: `/pricing/queryDiscountInfo`, data: reqData });
};

const fetchMembershipPackages = async <T>() => {
  const data = [{ key: "membership.price" }];
  return request<T>({ method: "POST", url: "/api/configurations", data: data });
};

const fetchMembershipProducts = async <T>() => {
  return request<T>({ method: "post", url: `/pricing/membership` });
};
const fetchV1Memberships = async <T>(reqData: { source: string; dataCountry: string; sourceVersion?: string }) => {
  return request<T>({ method: "post", url: `/pricing/v1/memberships`, data: reqData });
};

export interface SampleCreatorReport {
  id: number;
  order: number;
  ContentViews: string;
  Followers: string;
  LiveNum: string;
  LiveRevenue: string;
  Nickname: string;
  ProductCount: string;
  Revenue: string;
  VideoNum: string;
  VideoRevenue: string;
}

const fetchSampleCreatorReports = async () => {
  const data = [{ key: "sample.creator.report" }];
  const response = await request<{ "sample.creator.report": SampleCreatorReport[] }>({
    method: "POST",
    url: "/api/configurations",
    data: data,
  });
  return sortByOrder(response["sample.creator.report"]) || [];
};

export default {
  fetchPricingProducts,
  fetchIndProducts,
  createOrder,
  getFeture,
  queryOrder,
  queryMeLiveRecord,
  querySubscription,
  queryExchangeRate,
  queryDiscountInfo,
  fetchMembershipPackages,
  fetchMembershipProducts,
  fetchSampleCreatorReports,
  fetchV1Memberships,
  getPaymentMethod,
  requestPayMembership,
  checkAlipayQueryOrder,
};
